export const FIREBASE_APP_KEY = process.env.REACT_APP_FIREBASE_APP_KEY
